// extracted by mini-css-extract-plugin
module.exports = {"ButtonStyle":"Button_ButtonStyle__Ry7O3","Primary":"Button_Primary__qi9R_"};